// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3-RGk","selected":"Chip_selected__3Lvbc"};